import React, { useState, useEffect, useImperativeHandle, forwardRef, Fragment, useRef } from "react";
import PropTypes from 'prop-types';
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import { Close as CloseIcon } from '@mui/icons-material';
import FilterGroups from '../Common/FilterGroups';
import ConvertibilityConvertibleIcon from '../../../../icons/convertibility-convertible.svg?react';
import ShowAllIcon from '../../../../icons/show-all.svg?react';
import AppTypePhoneIcon from '../../../../icons/appType-Phone.svg?react';
import AppTypeDigitalIcon from '../../../../icons/appType-Digital.svg?react';
import StructureLevelIcon from '../../../../icons/structure-level.svg?react';
import StructureDecreasingIcon from '../../../../icons/structure-decreasing.svg?react';
import ConvertibilityNotConvertibleIcon from '../../../../icons/convertibility-NotConvertible.svg?react';

import "./QuoterFiltersCondensed.scss";

const FilterItem = (props) => {
  const [value, setValue] = useState("");

  const handleChange = (e) => {
    setValue(e.target.value);
    props.onChange(value);
  };
  useEffect(() => {
    if (props.onChange) {
      props.onChange(value);
    }
  }, [value]);
  return (
    <FormControl component="fieldset">
      {props.fields.map((field, i) => {
        const label = (
          <Fragment>
            <span className="filter-icon">{field.icon}</span>Show All
          </Fragment>
        );
        return <Fragment key={i}>
          {field.isAllFilters && <FormLabel component="legend">{field.formLabel}</FormLabel>}
          <RadioGroup aria-label={field.radio.label} name={field.radio.label} value={value} onChange={handleChange}>
            <FormControlLabel value={field.default} control={<Radio color="primary" />} label={label} labelPlacement="start" checked={field.isDefault} />
            {field.radio.map((r, i) => {
              const label = (
                <Fragment>
                  <span className="filter-icon">{r.icon}</span>{r.label}
                </Fragment>
              );
              return <FormControlLabel key={i} value={r.filterName} control={<Radio color="primary" />} label={label} labelPlacement="start" checked={r.selected} />;
            })}
          </RadioGroup>
        </Fragment>;
      })}
    </FormControl>
  );
};

export default forwardRef((props, ref) => {
  const filterPopoverRef = useRef(null);
  const [isFilterShow, setIsFilterShow] = useState(false);
  const [filterCount, setFilterCount] = useState(0);
  const [filterState, setFilterState] = useState(props.filterObject || {
    phoneOnly: false,
    digitalOnly: false,
    simplifiedIssueOnly: false,
    guaranteedIssueOnly: false,
    levelDeathBenefit: false,
    gradedDeathBenefit: false,
    modifiedDeathBenefit: false,
  });

  const updateFilterState = (key) => {
    const obj = { ...filterState };

    switch (key) {
      case "allApplicationType":
        obj["digitalOnly"] = false;
        obj["phoneOnly"] = false;
        break;
      case "digitalOnly":
        obj[key] = true;
        obj["phoneOnly"] = false;
        break;
      case "phoneOnly":
        obj[key] = true;
        obj["digitalOnly"] = false;
        break;
      case "allUnderwritingType":
        obj["simplifiedIssueOnly"] = false;
        obj["guaranteedIssueOnly"] = false;
        break;
      case "simplifiedIssueOnly":
        obj[key] = true;
        obj["guaranteedIssueOnly"] = false;
        break;
      case "guaranteedIssueOnly":
        obj[key] = true;
        obj["simplifiedIssueOnly"] = false;
        break;
      case "allDeathBenefitType":
        obj["levelDeathBenefit"] = false;
        obj["gradedDeathBenefit"] = false;
        obj["modifiedDeathBenefit"] = false;
        break;
      case "levelDeathBenefit":
        obj[key] = true;
        obj["gradedDeathBenefit"] = false;
        obj["modifiedDeathBenefit"] = false;
        break;
      case "gradedDeathBenefit":
        obj[key] = true;
        obj["levelDeathBenefit"] = false;
        obj["modifiedDeathBenefit"] = false;
        break;
      case "modifiedDeathBenefit":
        obj[key] = true;
        obj["levelDeathBenefit"] = false;
        obj["gradedDeathBenefit"] = false;
        break;
      default:
        break;
    };

    setFilterState(obj);
  };

  useImperativeHandle(ref, () => ({
    updateFilterState
  }));

  const resetFilters = () => {
    const obj = { ...filterState };

    Object.keys(obj).forEach(key => {
      if (obj[key] === true) {
        obj[key] = false;
      }
    });

    setFilterState(obj);
  };

  const showFilter = () => {
    setIsFilterShow(!isFilterShow);
  };

  const handleFilterClose = (event) => {
    if (filterPopoverRef.current && !filterPopoverRef.current.contains(event.target)) {
      setIsFilterShow(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleFilterClose);
    return () => {
      document.removeEventListener("mousedown", handleFilterClose);
    };
  }, []);

  useEffect(() => {
    if (props.setFilterObject) { props.setFilterObject(filterState); }
    const count = Object.values(filterState).filter(f => f === true).length;
    setFilterCount(count);
  }, [filterState, filterCount]);

  return (
    <Fragment>
      <div className="filter-control-condensed-wrapper ">
        <div className={`filter-container filter ${props.isAmerico ? "filter-padding-tight" : ""}`}>
          {!props.isAmerico && <Fragment>
            <div className="filter-popover-container">
              <button className="filter-control primary-color" disabled={props.isDisabled} onClick={showFilter}>
                Filters
                <div className={`filter-badge ${filterCount > 0 ? "count-mobile" : ""} primary-bg-color`}><p>{filterCount}</p></div>
              </button>
              <div className={`filter-popover ${isFilterShow ? "filter-popover-visible" : ""}`} ref={filterPopoverRef}>
                <div className="header">
                  <h3>Filters</h3>
                  <button onClick={showFilter}><CloseIcon /></button>
                </div>
                <div className="content">
                  <FilterGroups label="Application Type" inputs={
                    <FilterItem fields={[
                      {
                        formLabel: "Application Type",
                        isAllFilters: true,
                        default: "allApplicationType",
                        isDefault: (!filterState.digitalOnly && !filterState.phoneOnly),
                        icon: <ShowAllIcon className={(!filterState.digitalOnly && !filterState.phoneOnly) ? "primary-color" : "icon-color"} />,
                        radio: [
                          {
                            label: 'Digital Application',
                            filterName: 'digitalOnly',
                            selected: filterState.digitalOnly,
                            icon: <AppTypeDigitalIcon className={filterState.digitalOnly ? "primary-color" : "icon-color"} />,
                          },
                          {
                            label: 'Phone Application',
                            filterName: 'phoneOnly',
                            selected: filterState.phoneOnly,
                            icon: <AppTypePhoneIcon className={filterState.phoneOnly ? "primary-color" : "icon-color"} />,
                          }
                        ]
                      }]} onChange={updateFilterState} />} />
                  <FilterGroups label="Underwriting Type" inputs={
                    <FilterItem fields={[
                      {
                        formLabel: "Underwriting Type",
                        isAllFilters: true,
                        default: "allUnderwritingType",
                        isDefault: (!filterState.guaranteedIssueOnly && !filterState.simplifiedIssueOnly),
                        icon: <ShowAllIcon className={(!filterState.guaranteedIssueOnly && !filterState.simplifiedIssueOnly) ? "primary-color" : "icon-color"} />,
                        radio: [
                          {
                            label: 'Guaranteed Issue',
                            filterName: 'guaranteedIssueOnly',
                            selected: filterState.guaranteedIssueOnly,
                            icon: <ConvertibilityConvertibleIcon className={filterState.noMedicalExamOnly ? "primary-color" : "icon-color"} />,
                          },
                          {
                            label: 'Simplified Issue',
                            filterName: 'simplifiedIssueOnly',
                            selected: filterState.simplifiedIssueOnly,
                            icon: <ConvertibilityNotConvertibleIcon className={filterState.simplifiedIssueOnly ? "primary-color" : "icon-color"} />,
                          }
                        ]
                      }]} onChange={updateFilterState} />} />
                  <FilterGroups label="Death Benefit Type" inputs={
                    <FilterItem fields={[
                      {
                        formLabel: "Death Benefit Type",
                        isAllFilters: true,
                        default: "allDeathBenefitType",
                        isDefault: (!filterState.levelDeathBenefit && !filterState.gradedDeathBenefit && !filterState.modifiedDeathBenefit),
                        icon: <ShowAllIcon className={(!filterState.levelDeathBenefit && !filterState.gradedDeathBenefit && !filterState.modifiedDeathBenefit) ? "primary-color" : "icon-color"} />,
                        radio: [
                          {
                            label: 'Level Death Benefit',
                            filterName: 'levelDeathBenefit',
                            selected: filterState.levelDeathBenefit,
                            icon: <StructureLevelIcon className={filterState.levelDeathBenefit ? "primary-color" : "icon-color"} />,
                          },
                          {
                            label: 'Graded Death Benefit',
                            filterName: 'gradedDeathBenefit',
                            selected: filterState.gradedDeathBenefit,
                            icon: <StructureDecreasingIcon className={filterState.gradedDeathBenefit ? "primary-color" : "icon-color"} />,
                          },
                          {
                            label: 'Modified Death Benefit',
                            filterName: 'modifiedDeathBenefit',
                            selected: filterState.modifiedDeathBenefit,
                            icon: <StructureDecreasingIcon className={filterState.modifiedDeathBenefit ? "primary-color" : "icon-color"} />,
                          }
                        ]
                      }]} onChange={updateFilterState} />} />
                </div>
                <div className="footer">
                  <button className="filter-control primary-color" onClick={resetFilters}>Reset Filters</button>
                </div>
              </div>
            </div>
          </Fragment>}
        </div>
      </div>
    </Fragment>
  )
})

FilterItem.propTypes = {
  fields: PropTypes.array,
  onChange: PropTypes.func,
};
